import { useContext } from "react";
import { ModalContext } from "../contexts";

export const useModal = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error("useModal must be used within an ModalContext");
  }

  return context;
};
